<p>
	{{message}}
  </p>
  <div class="error-spinner"></div>